<template>
    <b-row>
        <b-col lg="12" class="px-0 mb-3">
            <h4 class="text-muted">รายละเอียดเส้นทางกลับคลัง</h4>
        </b-col>
        <b-col lg="12">
            <b-form-group 
                label="ระยะทางกลับคลัง (กม.)"
            >
                <b-form-input
                    v-model="form.distance_to_warehouse"
                    disabled
                />
            </b-form-group>
        </b-col>
    </b-row>
</template>

<script>
export default {
    props: {
        form: {
            type: Object
        }
    }
}
</script>
